
// src/connects/login-page.js

import { connect } from 'react-redux'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { pushRoute, replaceRoute } from '../actions/route'
import { validate } from '../helpers/form-validator'
import actions from '../actions'
import { translate } from 'react-i18next'
import ui from '../helpers/ui-state'
import { trackPage, trackHandlers } from '../helpers/analytics'
import { clearAlertMessage } from '../actions/alert-message'
import LoginHistory from '../actions/login-history'
import AccessToken from '../actions/access-token'
import GroupIdStore from '../actions/group-id-store'
import MentionsStore from '../actions/mentions-store'

export const mapStateToProps = (state, ownProps)=> {
  return {
    email: ownProps.location && ownProps.location.query && ownProps.location.query.email || null,
    login: state.sessions.login,
    isFailed: state.sessions.isFailed,
    password_change_required: state.sessions.password_change_required,
    passcode_required: state.sessions.passcode_required,
    password_required: state.sessions.password_required,
    sso_required: state.sessions.sso_required,
    sso_url: state.sessions.sso_url,
    trial_expired: state.alertMessage.trial_expired,
    re_trial: state.alertMessage.re_trial,
    alertMessage: state.alertMessage.message,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    validateAndSubmit: (props, event = undefined)=> {
      if (event && event.preventDefault)
        event.preventDefault();
      let rules = {
        email: { rule: 'isEmail' },
      }
      let opts = {}
      if (props.password_required) {
        rules.password = { rule: 'isRequired' }
        opts.password = props.ui.password
      } else if (props.password_change_required) {
        rules.password = { rule: 'isRequired' }
        rules.newPassword = { rule: 'isRequired' }
        rules.newPasswordConfirm = { rule: 'isSame', name: 'newPassword' }
        opts.password = props.ui.password
        opts.new_password = props.ui.newPassword
      } else if (props.passcode_required) {
        rules.password = { rule: 'isRequired' }
        rules.passcode = { rule: 'isNumber' }
        opts.password = props.ui.password
        opts.passcode = props.ui.passcode
      }
      validate(props.ui, rules, (errors, nextUI)=> {
        dispatch(clearAlertMessage())
        props.updateUI(nextUI)
        if (!errors) {
          dispatch(actions.login(props.ui.email, opts))
        }
      })
      return false
    },

    willMount: (props)=> {
      AccessToken.clear()
      GroupIdStore.clear()
      MentionsStore.clear()
      dispatch(actions.logoutCompleted())
      dispatch(actions.closeRightSidePage())
      LoginHistory.get((history)=> props.updateUI({ history }))
    },

    willUpdate: (props, nextProps)=> {
      if (!props.login && nextProps.login) {
        dispatch(actions.clearLoginStatus())
        replaceRoute('main', nextProps.location && nextProps.location.query)
      }
    },

    clearLoginStatus: (props)=> {
      props.updateUI({
        email: '',
        password: '',
        passcode: '',
        newPassword: '',
        newPasswordConfirm: '',
      })
      dispatch(actions.clearLoginStatus())
    },

    loadAccessToken: (access_token)=> {
      AccessToken.set(access_token, ()=> dispatch(actions.loginCompleted({ access_token })))
    },
    clearAlertMessage: ()=> dispatch(actions.clearAlertMessage())
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({
    state: {
      history: undefined,
      email: (props)=> props.email || '',
      password: '',
      passcode: '',
      newPassword: '',
      newPasswordConfirm: '',
      emailError: undefined,
      passwordError: undefined,
      passcodeError: undefined,
      newPasswordError: undefined,
      newPasswordConfirmError: undefined,
    }
  }),
  lifecycle,
  translate(),
  trackPage('login'),
  trackHandlers('validateAndSubmit', 'login_submit'),
)



// WEBPACK FOOTER //
// ./src/connects/login-page.js